import './../../../../../assets/sass/expired-modal.scss';

const processExpiredLoginTrigger = () => {
    if (typeof CRUserInfo != 'undefined' && typeof CRUserInfo.ready === 'function') {
        CRUserInfo.ready().then(processExpiredLogin)
    } else {
        $(document).on('userInfo_ready', processExpiredLogin)
    }
};

const processExpiredLogin = () => {
    if (CRUserInfo && CRUserInfo.isCroExpired()) {
        $('#subscriptionExpiredModal').modal('show');
        window.expiredSubscription = true;
        $(document).trigger('expiredSubscription');
    }
};

export default function expiredLogin() {
    processExpiredLoginTrigger();
}



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/ExpiredLogin/index.js